import React from "react";
import menuIcon from "../assets/menu.png";
import teraLogo from "../assets/Logos/logo.png";
import navMark from "../assets/Tera/nav-mark.png";
import instagramIcon from "../assets/instagram.png";
import Marquee from "./Marquee.js";
import { MARQUEE_HEIGHT, NAV_HEIGHT } from "./layout.js";
import { subscribeStripClearance } from "./stripClearance.js";
import "./Main.css";

const TERA_IG = "https://www.instagram.com/tera.oficial.ok";
const TICKETERA_LINK = "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga";
const BASES_SORTEO_LINK = "https://drive.google.com/file/d/1WS9L3PBmkk8kWEF3-Z5SKusn4FUe7wDB/view?usp=sharing";
const CUD_INSCRIPCION_LINK = "https://forms.gle/9Z22zNNsVaX2WWGW7";
const CUD_PROTOCOLO_LINK = "https://drive.google.com/file/d/1jDKfbaVDh9W4vi7th94JQ7hnbT7ipfxE/view?usp=sharing";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menu: false, acred: false, stripClearance: 0 };
  }

  componentDidMount() {
    this.unsubscribeStrip = subscribeStripClearance((stripClearance) =>
      this.setState({ stripClearance }),
    );
  }

  componentWillUnmount() {
    if (this.unsubscribeStrip) this.unsubscribeStrip();
  }

  getClass = (section) =>
    this.props.state.toLowerCase() === section.toLowerCase()
      ? "label-header-selected"
      : "label-header-not-selected";

  handleRedirect = (section) => {
    this.props.redirect(section);
    this.setState({ menu: false, acred: false });
  };

  renderSorteoButton(mobile) {
    return (
      <button
        onClick={() => window.open(BASES_SORTEO_LINK, "_blank", "noopener,noreferrer")}
        title="Bases y condiciones del sorteo"
        aria-label="Bases y condiciones del sorteo"
        style={{
          backgroundColor: "var(--tera-cyan)",
          color: "#000",
          fontFamily: "var(--tera-pixel)",
          fontWeight: 700,
          fontSize: mobile ? "0.8em" : "0.85em",
          letterSpacing: mobile ? undefined : "-1px",
          padding: mobile ? "6px 12px" : "8px 16px",
          borderRadius: mobile ? "16px" : "20px",
          border: "none",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        SORTEO
      </button>
    );
  }

  getNavFontPx = () => Math.max(11, Math.min(20.8, (window.innerWidth - 755) / 38.7));
  getNavFont = () => `${this.getNavFontPx().toFixed(1)}px`;
  getNavSpacing = () => `${(-this.getNavFontPx() * 0.144).toFixed(2)}px`;

  renderAcreditaciones(mobile) {
    const open = this.state.acred;
    const openLink = (url) => {
      if (url) window.open(url, "_blank", "noopener,noreferrer");
    };
    const linkStyle = {
      background: "none",
      border: "none",
      padding: 0,
      color: "#fff",
      fontFamily: "var(--tera-italic)",
      fontStyle: "italic",
      fontWeight: 600,
      fontSize: mobile ? "15px" : "14px",
      textAlign: mobile ? "right" : "left",
      cursor: "pointer",
    };

    return (
      <div
        style={{
          position: mobile ? "static" : "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: mobile ? "flex-end" : "flex-start",
        }}
        onMouseEnter={mobile ? undefined : () => this.setState({ acred: true })}
        onMouseLeave={mobile ? undefined : () => this.setState({ acred: false })}
      >
        <button
          onClick={() => this.setState((p) => ({ acred: !p.acred }))}
          className="label-header-not-selected"
          style={{
            fontSize: mobile ? undefined : this.getNavFont(),
            lineHeight: mobile ? undefined : 1,
            letterSpacing: mobile ? undefined : this.getNavSpacing(),
            textAlign: mobile ? "right" : undefined,
            color: open ? "var(--tera-yellow)" : undefined,
          }}
        >
          ACREDITACIONES
        </button>

        {open && (
          <div
            style={
              mobile
                ? { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "6px", padding: "6px 5px 2px" }
                : {
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    minWidth: "170px",
                    backgroundColor: "#000",
                    padding: "14px 18px 16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    zIndex: 6000,
                  }
            }
          >
            <div
              style={{
                fontFamily: "var(--tera-pixel)",
                fontWeight: 700,
                color: "var(--tera-cyan)",
                fontSize: mobile ? "20px" : "22px",
                lineHeight: 1,
              }}
            >
              CUD
            </div>
            <button onClick={() => openLink(CUD_INSCRIPCION_LINK)} style={linkStyle}>
              Inscripcion
            </button>
            <button onClick={() => openLink(CUD_PROTOCOLO_LINK)} style={linkStyle}>
              Protocolo
            </button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { menu } = this.state;
    const isMobile = window.innerWidth <= 1180;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          zIndex: 5000,
        }}
      >
        <Marquee />
        <div
          style={{
            position: "relative",
            backgroundColor: "var(--tera-bg)",
            height: `${NAV_HEIGHT}px`,
            boxSizing: "border-box",
            overflow: "visible",
          }}
        >
          <img
            src={teraLogo}
            alt="TERA"
            onClick={() => this.handleRedirect("Home")}
            style={{
              position: "absolute",
              left: "20px",
              top: isMobile ? "70%" : "110%",
              transform: isMobile
                ? "translateY(calc(-50% - 10px))"
                : "translateY(calc(-50% - 14px))",
              height: isMobile ? "100px" : "150px",
              width: "auto",
              cursor: "pointer",
              objectFit: "contain",
              zIndex: 2,
            }}
          />

          {!isMobile ? (
            <>
              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  whiteSpace: "nowrap",
                  zIndex: 1,
                }}
              >
                {[
                  { label: "TERA SEÑAL", key: "Home" },
                  { label: "SECTORES", key: "PlanoSectores" },
                  { label: "ENTRADAS", key: "Sectores" },
                  { label: "COMUNIDAD", key: "Contacto" },
                ].map(({ label, key }, i) => (
                  <React.Fragment key={key}>
                    {i > 0 && (
                      <span style={{ color: "#fff", fontSize: "22px", margin: "0 4px" }}>·</span>
                    )}
                    <button
                      onClick={() => this.handleRedirect(key)}
                      className={this.getClass(key.toLowerCase())}
                      style={{
                        fontSize: this.getNavFont(),
                        lineHeight: 1,
                        letterSpacing: this.getNavSpacing(),
                      }}
                    >
                      {key === "Home" ? (
                        <>
                          <span style={{ color: "var(--tera-pink)", fontFamily: "inherit" }}>TERA</span>
                          <span style={{ color: "#fff", fontFamily: "inherit" }}> SEÑAL</span>
                        </>
                      ) : key === "Sectores" ? (
                        <span style={{  fontFamily: "inherit" }}>{label}</span>
                      ) : (
                        label
                      )}
                    </button>
                  </React.Fragment>
                ))}

                <span style={{ color: "#fff", fontSize: "22px", margin: "0 4px" }}>·</span>
                {this.renderAcreditaciones(false)}

                <button
                  onClick={() => window.open(TICKETERA_LINK, "_blank", "noopener,noreferrer")}
                  style={{
                    marginLeft: window.innerWidth < 1400 ? "8px" : "16px",
                    backgroundColor: "var(--tera-yellow)",
                    color: "#000",
                    fontFamily: "var(--tera-pixel)",
                    fontWeight: 700,
                    fontSize: "0.85em",
                    letterSpacing: "-1px",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    border: "none",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  COMPRÁ YA
                </button>

                <span style={{ marginLeft: "8px", display: "inline-flex" }}>
                  {this.renderSorteoButton(false)}
                </span>
              </div>

              <div
                style={{
                  position: "absolute",
                  right: "4%",
                  top: "50%",
                  transform: "translateY(-50%)",
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                }}
              >
                <a
                  href={TERA_IG}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram de TERA"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    src={instagramIcon}
                    alt="Instagram"
                    style={{ height: "26px", width: "auto" }}
                  />
                </a>

                <button
                  onClick={() =>
                    window.open(
                      "https://forms.gle/Ytf63tfFC1sxycEt7",
                      "_blank",
                      "noopener,noreferrer",
                    )
                  }
                  className="tera-activate-badge"
                >
                  <img
                    src={navMark}
                    alt=""
                    style={{ height: "25px", width: "auto" }}
                  />
                </button>
              </div>
            </>
          ) : (
            <div
              style={{
                position: "absolute",
                right: "20px",
                top: "50%",
                transform: "translateY(-50%)",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <button
                onClick={() => window.open(TICKETERA_LINK, "_blank", "noopener,noreferrer")}
                style={{
                  backgroundColor: "var(--tera-yellow)",
                  color: "#000",
                  fontFamily: "var(--tera-pixel)",
                  fontWeight: 700,
                  fontSize: "0.8em",
                  padding: "6px 12px",
                  borderRadius: "16px",
                  border: "none",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                COMPRÁ YA
              </button>

              <div
                onClick={() => this.setState((p) => ({ menu: !p.menu }))}
                style={{ cursor: "pointer" }}
              >
                <img src={menuIcon} alt="menu" style={{ width: "30px" }} />
              </div>
            </div>
          )}
        </div>

        {isMobile && menu && (
          <div
            style={{
              position: "absolute",
              top: `${MARQUEE_HEIGHT + NAV_HEIGHT + 7}px`,
              right: 0,
              width: "230px",
              backgroundColor: "var(--tera-bg)",
              borderBottomLeftRadius: 8,
              padding: "12px",
              zIndex: 5500,
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {[
              { label: "TERA SEÑAL", key: "Home" },
              { label: "SECTORES", key: "PlanoSectores" },
              { label: "ENTRADAS", key: "Sectores" },
              { label: "COMUNIDAD", key: "Contacto" },
            ].map(({ label, key }) => (
              <button
                key={key}
                onClick={() => this.handleRedirect(key)}
                className={this.getClass(key.toLowerCase())}
                style={{
                  textAlign: "right",
                  fontFamily: "var(--tera-pixel)",
                }}
              >
                {key === "Home" ? (
                  <>
                    <span style={{ color: "var(--tera-pink)", fontFamily: "inherit" }}>TERA</span>
                    <span style={{ color: "#fff", fontFamily: "inherit" }}> SEÑAL</span>
                  </>
                ) : (
                  label
                )}
              </button>
            ))}

            {this.renderAcreditaciones(true)}

            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "14px" }}>
              {this.renderSorteoButton(true)}
              <a
                href={TERA_IG}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram de TERA"
                style={{ display: "flex", alignItems: "center" }}
              >
                <img
                  src={instagramIcon}
                  alt="Instagram"
                  style={{ height: "22px", width: "auto" }}
                />
              </a>

              <button
                onClick={() =>
                  window.open(
                    "https://forms.gle/Ytf63tfFC1sxycEt7",
                    "_blank",
                    "noopener,noreferrer",
                  )
                }
                className="tera-activate-badge"
              >
                <img
                  src={navMark}
                  alt=""
                  style={{ height: "22px", width: "auto" }}
                />
              </button>
            </div>
          </div>
        )}

        <button
          onClick={() => this.handleRedirect("Home")}
          aria-label="Ir al inicio"
          style={{
            position: "fixed",
            right: "16px",
            bottom: isMobile ? `${Math.max(112, this.state.stripClearance)}px` : "16px",
            transition: "bottom 0.2s ease",
            width: "44px",
            height: "44px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "rgba(253, 30, 123, 0.28)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 4900,
          }}
        >
          <svg viewBox="0 0 24 24" style={{ width: "55%", height: "55%" }}>
            <path
              d="M6 15 12 9l6 6"
              fill="none"
              stroke="var(--tera-pink)"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    );
  }
}

export default Header;
